import { pixels } from "../images"

export default function Pixelart() {
    return (
      <div className="all-pixel-box">
        {pixels.map((set, index) => (
          <div key = {set + index} className="pixelart-box" >
            {set.map((image, index) => (
              <img key={image} src={image} alt={`pixel-art-${index}` } className="pixelart" />
            ))}
          </div>
      ))}
      </div>
    )
}